import { useEffect } from 'react';
import { useNotify, useRefresh } from 'react-admin';
import { useSocket } from '../SocketContext'; // تأكد من المسار الصحيح

const AdminNotificationListener = () => {
    const socket = useSocket();
    const notify = useNotify();
    const refresh = useRefresh();

    useEffect(() => {
        if (!socket) return;

        // 1. توثيق الهوية
        socket.on('new_verification_request', () => {
            notify('🔔 طلب توثيق هوية جديد', { type: 'info', autoHideDuration: 5000 });
            refresh(); // تحديث القائمة تلقائياً
        });

        // 2. توثيق السيارة
        socket.on('new_car_verification', () => {
            notify('🚗 طلب توثيق سيارة جديد', { type: 'info', autoHideDuration: 5000 });
            refresh();
        });

        // 3. رحلة جديدة
        socket.on('new_ride_created', () => {
            notify('🆕 تم إضافة رحلة جديدة', { type: 'success', autoHideDuration: 3000 });
        });

        // 4. بلاغ جديد
        socket.on('new_report', () => {
            notify('⚠️ تم تقديم بلاغ جديد', { type: 'warning', autoHideDuration: 10000 }); // مدة أطول
            refresh();
        });
        
        // 5. رسائل الدعم
        socket.on('new_support_chat', () => {
             notify('💬 محادثة دعم فني جديدة', { type: 'info' });
             refresh();
        });

        socket.on('admin_new_support_message', (data) => {
             // يمكنك عرض جزء من الرسالة
             notify(`رسالة دعم: ${data.message.content || 'مرفق'}`, { type: 'info' });
        });

        // تنظيف المستمعين عند الخروج
        return () => {
            socket.off('new_verification_request');
            socket.off('new_car_verification');
            socket.off('new_ride_created');
            socket.off('new_report');
            socket.off('new_support_chat');
            socket.off('admin_new_support_message');
        };
    }, [socket, notify, refresh]);

    return null; // هذا المكون لا يعرض شيئاً، هو فقط للاستماع
};

export default AdminNotificationListener;